import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {routeAnimation} from '../../../route.animation';
import {FormBuilder, Validators} from '@angular/forms';
import {FormsService} from '../../../_services/forms.service';
import {Subscription} from 'rxjs/Subscription';
import {ActivatedRoute, Params} from '@angular/router';
import {PreviousUrlService} from '../../../_services/previous-url.service';
import {ReportsService} from '../../../_services/reports.service';
import {Reports} from '../../../_interfaces/reports/reports';
import {ApiService} from '../../../_interceptors/api.service';
import {PageTitleService} from '../../../_services/page-title.service';
import {environment} from '../../../../environments/environment';
import * as moment from 'moment';

@Component({
	selector: 'app-reports-edit',
	templateUrl: './reports-edit.component.html',
	styleUrls: ['./reports-edit.component.scss'],
	animations: [routeAnimation]
})

export class ReportsEditComponent implements OnInit, OnDestroy {

	@HostBinding('@routeAnimation') routerTransition = true;

	public report_id: number = null;
	public dataLoaded: boolean = false;
	public missingData: Array<string> = [];
	public report: Reports = null;
	public year: number = null;

	public reportsEditForm = this.formBuilder.group({
		type: ['', Validators.required],
		report_nr: [''],
		week: [''],
		client_description: ['']
	});

	private _errorsSubscription: Subscription = null;
	private _activatedRouteSubscription: Subscription = null;

	constructor(private activatedRoute: ActivatedRoute,
				private apiService: ApiService,
				public reportsService: ReportsService,
				public formsService: FormsService,
				private previousUrlService: PreviousUrlService,
				private formBuilder: FormBuilder,
				private pageTitleService: PageTitleService) {
	}

	ngOnInit(): void {
		this.year = parseInt(moment().format('Y'), 10);
		this.apiService.connectionChanged.subscribe(online => {
			if (online && this.missingData.length) {
				this.missingData = [];
				this.loadData();
			}
		});

		this.formsService.form = this.reportsEditForm;

		this._errorsSubscription = this.reportsService.errors.subscribe(errors => {
			this.formsService.processErrors(errors);
		});

		this._activatedRouteSubscription = this.activatedRoute.params.subscribe((params: Params) => {
			this.report_id = parseInt(params['report_id'], 10);

			this.loadData();

			this.previousUrlService.setPreviousUrlIfNull('/reports');
		});

		this._errorsSubscription = this.reportsService.errors.subscribe(errors => {
			this.formsService.processErrors(errors);
		});
	}

	ngOnDestroy(): void {
		if (this._activatedRouteSubscription !== null) {
			this._activatedRouteSubscription.unsubscribe();
		}

		if (this._errorsSubscription !== null) {
			this._errorsSubscription.unsubscribe();
		}
	}

	loadData() {
		this.reportsService.getReport(this.report_id).then((data: Reports) => {
			if (typeof data !== 'undefined') {
				if (typeof data.type === 'undefined') {
					data.type = 'warehouse';
				}

				this.formsService.populateForm(data);
				this.reportsEditForm.controls['type'].setValue(data.type);

				let week = this.reportsEditForm.controls['week'],
					reportNr = this.reportsEditForm.controls['report_nr'];
				if (data.type === 'warehouse') {
					week.setValidators(null);
					week.setValue('');
					week.updateValueAndValidity();
					reportNr.setValue(data.report_nr);
					reportNr.setValidators(Validators.required);
					reportNr.updateValueAndValidity();
				} else {
					week.setValue(data.report_nr.replace(/^\D+/g, ''));
					week.setValidators(Validators.required);
					week.updateValueAndValidity();
					reportNr.setValue('');
					reportNr.setValidators(null);
					reportNr.updateValueAndValidity();
				}

				this.pageTitleService.setTitle(data.report_nr + ' | Edit report | ' + environment.webappName);
				this.pageTitleService.setPageTitle(data.report_nr);

				this.dataLoaded = true;
			} else {
				this.missingData.push('Rapportage');
			}
		});
	}
}
